import React from 'react';
import './student-performance-baseline-finishline-inline.scss';
import { getImageSource } from '../../../../utility/image-source';
import { ImageConstants } from '../../../../constants/constants';
import Loading from '../../../common/loading/loading';
import SessionCache from '../../../routes/session-cache';
import SchoolApi from '../../../../apis/school';
import ReactTooltip from 'react-tooltip';

class StudentPerformanceBaselineFinishlineInline extends React.Component {

    state = {
        isLoading: false,
        summary: {},
        students: [],
        notAttemptedStudents: [],
        userInfo: {},
        activeTooltip: null
    }

    componentDidMount() {
        const userInfo = SessionCache.getUser();
        this.setState({ userInfo });
        this.fetchReport();
    }

    fetchReport() {
        const { selectedItem } = this.props;
        if (!selectedItem) return;

        // Extract chapterName from the selected item
        const chapterName = Array.isArray(selectedItem.chapters) && selectedItem.chapters.length > 0
            ? (typeof selectedItem.chapters[0] === 'object'
                ? (selectedItem.chapters[0].title || selectedItem.chapters[0].name || '')
                : selectedItem.chapters[0])
            : (selectedItem.chapterTitle || selectedItem.chapterName || selectedItem.chapter || '');

        const payload = {
            board: selectedItem.board,
            classText: selectedItem.class,
            schoolAssessmentId: typeof (selectedItem._id || selectedItem.schoolAssessmentId) === 'object'
                ? ((selectedItem._id || selectedItem.schoolAssessmentId).$oid || (selectedItem._id || selectedItem.schoolAssessmentId).toString())
                : (selectedItem._id || selectedItem.schoolAssessmentId || selectedItem.homeworkId || selectedItem.id || '')
        };
        if (selectedItem.section) payload.section = selectedItem.section;
        if (chapterName) payload.chapterName = chapterName;
        if (selectedItem.chapterKey) payload.chapterKey = selectedItem.chapterKey;
        if (selectedItem.questionSetId) payload.questionSetId = selectedItem.questionSetId;

        this.setState({ isLoading: true });

        SchoolApi.getStudentPerformanceBaselineFinishlineReport(payload)
            .then(res => {
                if (res) {
                    this.setState({
                        summary: res.summary || {},
                        students: res.students || [],
                        notAttemptedStudents: res.notAttemptedStudents || [],
                        isLoading: false
                    });
                } else {
                    this.setState({ isLoading: false });
                }
            })
            .catch(err => {
                console.error('[StudentPerformanceBLFL] Error:', err);
                this.setState({ isLoading: false });
            });
    }

    downloadPdf = () => {
        const { selectedItem } = this.props;
        if (!selectedItem) return;

        const chapterName = Array.isArray(selectedItem.chapters) && selectedItem.chapters.length > 0
            ? (typeof selectedItem.chapters[0] === 'object'
                ? (selectedItem.chapters[0].title || selectedItem.chapters[0].name || '')
                : selectedItem.chapters[0])
            : (selectedItem.chapterTitle || selectedItem.chapterName || selectedItem.chapter || '');

        const payload = {
            format: 'pdf',
            board: selectedItem.board,
            classText: selectedItem.class,
            schoolAssessmentId: typeof (selectedItem._id || selectedItem.schoolAssessmentId) === 'object'
                ? ((selectedItem._id || selectedItem.schoolAssessmentId).$oid || (selectedItem._id || selectedItem.schoolAssessmentId).toString())
                : (selectedItem._id || selectedItem.schoolAssessmentId || selectedItem.homeworkId || selectedItem.id || '')
        };
        if (selectedItem.section) payload.section = selectedItem.section;
        if (chapterName) payload.chapterName = chapterName;
        if (selectedItem.chapterKey) payload.chapterKey = selectedItem.chapterKey;
        if (selectedItem.questionSetId) payload.questionSetId = selectedItem.questionSetId;

        this.setState({ isLoading: true });

        SchoolApi.getStudentPerformanceBaselineFinishlineReport(payload)
            .then(response => {
                this.setState({ isLoading: false });
                const link = response.pdfLink || (response.data && response.data.pdfLink) || response.url || (response.data && response.data.url);
                if (link) {
                    window.open(link, '_blank');
                }
            })
            .catch(err => {
                console.error('[StudentPerformanceBLFL] Error downloading PDF:', err);
                this.setState({ isLoading: false });
            });
    }

    onClickBack() {
        this.props.close && this.props.close();
    }

    getDate(timeStamp) {
        if (!timeStamp) return '-';
        let dateFormat = new Date(timeStamp).toDateString();
        let parts = dateFormat.split(' ');
        return `${parts[2]} ${parts[1]} ${parts[3]}`;
    }

    formatPercent(value) {
        return `${Number(value).toFixed(2)}%`;
    }

    getGainClass(gain) {
        if (gain === null || gain === undefined) return '';
        if (gain > 0) return 'gain-positive';
        if (gain < 0) return 'gain-negative';
        return 'gain-zero';
    }

    renderGain(gain) {
        if (gain === null || gain === undefined) return <span className="gain-zero">-</span>;
        const arrow = gain > 0 ? '▲' : gain < 0 ? '▼' : '';
        const prefix = gain > 0 ? '+' : '';
        const cls = this.getGainClass(gain);
        return (
            <span className={cls}>
                {arrow} {prefix}{Number(gain).toFixed(2)}%
            </span>
        );
    }

    getSectionTitle(key) {
        const titles = {
            revise: 'Chapter Revision',
            practice: 'Practice',
            prepareAndCaseStudy: 'Prepare & Case Study',
            cheatSheet: 'Cheat Sheet',
            thingsToRemember: 'Things To Remember',
            commonErrors: 'Common Errors',
            tipsAndTricks: 'Tips & Tricks'
        };
        return titles[key] || key;
    }

    render() {
        const { selectedItem } = this.props;
        const { isLoading, summary, students, notAttemptedStudents, userInfo } = this.state;

        return (
            <div className="spbfl-inline-wrapper">
                {isLoading && <Loading />}

                {/* Back */}
                <div>
                    <img
                        alt=""
                        className="back-icon cursor-pointer mb-3"
                        src={getImageSource(ImageConstants.BACK_ICON)}
                        onClick={() => this.onClickBack()}
                    />
                </div>

                {/* Title row */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="spbfl-title">Student Performance Baseline Finishline Report</div>
                    <div 
                        className="cursor-pointer" 
                        onClick={this.downloadPdf}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#005DFF',
                            color: '#ffffff',
                            padding: '8px 16px',
                            borderRadius: '6px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                        }}
                    >
                        <img src={getImageSource(ImageConstants.DOWNLOAD_ICON_WHITE)} alt="" className="mr-2" style={{ width: '20px' }} />
                        <span style={{ fontWeight: 'bold', fontSize: '14px' }}>Download PDF</span>
                    </div>
                </div>
                <div className="spbfl-header-row mb-3">
                    <div className="spbfl-school-name">{userInfo?.schoolInfo?.name}</div>
                </div>

                {!isLoading && (
                    <div className="spbfl-card">

                        {/* Summary section */}
                        <div className="spbfl-section-header">Summary</div>
                        <div className="row mt-4 mb-4 px-3">
                            <div className="col-md-4 summary-col">
                                <div className="sg-label">Class</div>
                                <div className="sg-colon">:</div>
                                <div className="sg-value">{selectedItem && selectedItem.class ? selectedItem.class.split(' ')[1] || selectedItem.class : '-'}</div>

                                <div className="sg-label">Section</div>
                                <div className="sg-colon">:</div>
                                <div className="sg-value">{selectedItem && selectedItem.section ? selectedItem.section : '-'}</div>

                                <div className="sg-label">Total Students</div>
                                <div className="sg-colon">:</div>
                                <div className="sg-value">{summary.totalStudents || 0}</div>
                            </div>

                            <div className="col-md-4 summary-col">
                                <div className="sg-label">Date</div>
                                <div className="sg-colon">:</div>
                                <div className="sg-value">{this.getDate(selectedItem && selectedItem.createdDateTimestamp)}</div>

                                <div className="sg-label">Chapter</div>
                                <div className="sg-colon">:</div>
                                <div className="sg-value">{selectedItem && (selectedItem.chapter || '-')}</div>

                                <div className="sg-label">Baseline Attempted</div>
                                <div className="sg-colon">:</div>
                                <div className="sg-value">{summary.baselineAttempted || 0}</div>
                            </div>

                            <div className="col-md-4 summary-col">
                                <div className="sg-label">Finishline Attempted</div>
                                <div className="sg-colon">:</div>
                                <div className="sg-value">{summary.finishlineAttempted || 0}</div>

                                <div className="sg-label">Avg Baseline Score %</div>
                                <div className="sg-colon">:</div>
                                <div className="sg-value">{this.formatPercent(summary.avgBaselinePercent || 0)}</div>

                                <div className="sg-label">Avg Finishline Score %</div>
                                <div className="sg-colon">:</div>
                                <div className="sg-value">{this.formatPercent(summary.avgFinishlinePercent || 0)}</div>
                            </div>
                        </div>

                        {/* Student table */}
                        <div className="spbfl-section-header">Student Performance Details</div>
                        <div className="competency-table mt-4 table-responsive">
                            <table className="table table-bordered table-striped mb-0" style={{ tableLayout: 'fixed' }}>
                                <colgroup>
                                    <col style={{ width: '6%' }} />
                                    <col style={{ width: '28%' }} />
                                    <col style={{ width: '16%' }} />
                                    <col style={{ width: '16%' }} />
                                    <col style={{ width: '16%' }} />
                                    <col style={{ width: '18%' }} />
                                </colgroup>
                                <thead className="class-header">
                                    <tr className="first-header-bg">
                                        <th>S.No</th>
                                        <th>Name</th>
                                        <th>Baseline Score %</th>
                                        <th>Revision %</th>
                                        <th>Finishline Score %</th>
                                        <th>Relative Gain</th>
                                    </tr>
                                </thead>
                                <tbody className="class-body">
                                    {students && students.length > 0 ? (
                                        students.map((s, idx) => (
                                            <tr key={s.userId || idx}>
                                                <td>{idx + 1}</td>
                                                <td>{s.name}</td>
                                                <td>{s.baselinePercent !== null && s.baselinePercent !== undefined ? this.formatPercent(s.baselinePercent) : '-'}</td>
                                                <td>
                                                    <div className="completion-cell">
                                                        <span>{s.completion !== null && s.completion !== undefined ? this.formatPercent(s.completion) : '-'}</span>
                                                        {s.completedSections && s.completedSections.length > 0 && (
                                                            <span className="info-anchor">
                                                                <img
                                                                    className="cursor-pointer"
                                                                    src={getImageSource(ImageConstants.INFO_BLUE)}
                                                                    alt="Completed sections info"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        const tooltipId = `spbfl-sections-${idx}`;
                                                                        if (this.state.activeTooltip === tooltipId) {
                                                                            ReactTooltip.hide();
                                                                            this.setState({ activeTooltip: null });
                                                                        } else {
                                                                            ReactTooltip.hide();
                                                                            this.setState({ activeTooltip: tooltipId }, () => {
                                                                                ReactTooltip.show(e.currentTarget);
                                                                            });
                                                                        }
                                                                    }}
                                                                    data-tip
                                                                    data-for={`spbfl-sections-${idx}`}
                                                                />
                                                                <ReactTooltip
                                                                    id={`spbfl-sections-${idx}`}
                                                                    place="right"
                                                                    effect="solid"
                                                                    globalEventOff="click"
                                                                    clickable={true}
                                                                    className="spbfl-tooltip"
                                                                    afterHide={() => {
                                                                        if (this.state.activeTooltip === `spbfl-sections-${idx}`) {
                                                                            this.setState({ activeTooltip: null });
                                                                        }
                                                                    }}
                                                                >
                                                                    <div className="text-left">
                                                                        <div className="mb-2 pb-1 tooltip-header">Completed Sections</div>
                                                                        <ul className="pl-3 mb-0" style={{ listStyleType: 'disc' }}>
                                                                            {s.completedSections.map(section => (
                                                                                <li key={section}>{this.getSectionTitle(section)}</li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                </ReactTooltip>
                                                            </span>
                                                        )}
                                                    </div>
                                                </td>
                                                <td>{s.finishlinePercent !== null && s.finishlinePercent !== undefined ? this.formatPercent(s.finishlinePercent) : '-'}</td>
                                                <td>{this.renderGain(s.relativeGain)}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6" className="text-center text-muted py-3">
                                                No student data found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Not Attempted Students */}
                        <div className="not-attempted-label mt-4 mb-2">Students who haven't completed both assessments:</div>
                        {notAttemptedStudents && notAttemptedStudents.length > 0 ? (
                            <div className="not-attempted-students-list">
                                {notAttemptedStudents.map((name, idx) => (
                                    <span key={idx} className="not-attempted-tag">
                                        {name}{idx < notAttemptedStudents.length - 1 ? ', ' : ''}
                                    </span>
                                ))}
                            </div>
                        ) : (
                            <div className="light-text mb-4">No Students</div>
                        )}

                    </div>
                )}
            </div>
        );
    }
}

export default StudentPerformanceBaselineFinishlineInline;
